<template>

    <NewFileTabTour :tour-name-key="tourNameKey"
                    :tour-steps="quickStartSteps"
                    :tour-available="tourAvailable"
                    />

</template>

<script lang="js">
    import { defineComponent } from 'vue';
    import { userGuideService } from '../userGuideService'

    import NewFileTabTour from './NewFileTabTour.vue'

    export default defineComponent({
        props: {
            tourAvailable: {
                type: Boolean,
                default: false,
            }
        },
        components: {
            NewFileTabTour,
        },
        data() {
            return {
                tourNameKey: "quickStartTour.tourName",
                quickStartSteps: userGuideService.getQuickStartGuide(),
            };
        },
    })
</script>
